import axios from 'axios';

// Accept an origin or an API base URL, but add the /api prefix exactly once.
const hostaddress = (process.env.REACT_APP_API_URL || '/api/')
  .replace(/\/+$/, '')
  .replace(/(?:\/api)+$/, '');
const requestUrl = (url) => hostaddress + '/api/' + url.replace(/^\/+/, '').replace(/^api\/+/, '');

export async function get(url, params = null, token) {
  console.log('hostaddress', hostaddress);
  try {
    const response = await axios.get(requestUrl(url), {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params
    });
    return response.data;
  } catch (error) {
    console.error('GET request failed:', error);
    throw error.response ? error.response.data : error;
  }
}

export async function post(url, params, token) {
  console.log('hostaddress', hostaddress);

  try {
    const response = await axios.post(requestUrl(url), params, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('POST request failed:', error);
    throw error.response ? error.response.data : error;
  }
}

export async function uploadFile(url, formData, token) {
  try {
    const response = await axios.post(requestUrl(url), formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('File upload failed:', error);
    throw error.response ? error.response.data : error;
  }
}

export async function downloadFile(url, token) {
  try {
    const response = await axios.get(requestUrl(url), {
      headers: {
        Authorization: `Bearer ${token}`
      },
      responseType: 'blob'
    });
    return response; // Return the full response including headers
  } catch (error) {
    console.error('Download file failed:', error);
    throw error.response ? error.response.data : error;
  }
}
